import { AbstractComponentStore } from '@coach-bot/data-access/shared/stores/abstract/abstract-component.store';

interface ContentScriptState {
  backendUrl: string;
  learningApp: string;
  profileEmail: string;
  sentryInitialized: boolean;
}

const DEFAULT_STATE: ContentScriptState = {
  backendUrl: '',
  learningApp: '',
  profileEmail: '',
  sentryInitialized: false,
};

export class ContentScriptStore extends AbstractComponentStore<ContentScriptState> {
  static instance: ContentScriptStore;

  // Main selectors
  readonly backendUrl$ = this.select('backendUrl');
  readonly learningApp$ = this.select('learningApp');
  readonly profileEmail$ = this.select('profileEmail');
  readonly sentryInitialized$ = this.select('sentryInitialized');

  private constructor() {
    super(DEFAULT_STATE);
  }

  static getInstance(): ContentScriptStore {
    if (!this.instance) {
      this.instance = new ContentScriptStore();
    }
    return this.instance;
  }

  setBackendUrl(data: string): void {
    this.updateStateProp('backendUrl', data);
  }

  setLearningApp(data: string): void {
    this.updateStateProp('learningApp', data);
  }

  setProfileEmail(data: string): void {
    this.updateStateProp('profileEmail', data);
  }

  setSentryInitialized(data: boolean): void {
    this.updateStateProp('sentryInitialized', data);
  }
}
